import { useMemo } from 'react';

import { Bean, ValidationRules } from '@dreryk/react-common';
import { DatePicker, StyledMaxWidth } from '@dreryk/react-components';

import { guardianTranslationKeys } from '../../../../../translations';
import { GuardianMedicalLeaveFormController } from '../../../guardianMedicalLeave/guardianMedicalLeave.types';

type GuardianBirthDateFieldProps = Pick<GuardianMedicalLeaveFormController, 'register'>;

export const GuardianBirthDateField = (props: GuardianBirthDateFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(
      () => ({
         required: true,
      }),
      []
   );

   return (
      <StyledMaxWidth maxWidth={345}>
         <DatePicker
            testId={'guardianBirthDate'}
            controller={props.register('birthDate', validationRules)}
            label={guardianTranslationKeys.guardianBirthDate}
            placeholder={'patient:datePlaceholder'}
            dayValidators={'dayAfterToday'}
            withNavigationArrows
         />
      </StyledMaxWidth>
   );
};
